import {
  type NamespaceKey,
  type NamespacesPossibleKeys,
  type UseTranslationReturnType,
} from './types'

/**
 * Get the translated country name from an ISO country code.
 *
 * @param isoCountryCode The ISO country code (e.g. 'FR', 'GB')
 * @param t The translation function from useTranslation(['countries'])
 * @param fallback The fallback name if translation fails or isoCountryCode is missing
 * @returns The translated country name or the fallback/isoCountryCode
 */
export function getCountryTranslation(
  isoCountryCode: string | undefined | null,
  t: UseTranslationReturnType<NamespaceKey>['t'],
  fallback?: string,
): string | undefined {
  if (!isoCountryCode) return fallback

  const countryKey =
    `countries:${isoCountryCode.toUpperCase()}` as NamespacesPossibleKeys<NamespaceKey>
  const translatedCountry = t(countryKey)

  // If translation fails (returns the key), fallback to the original code or country string
  return translatedCountry !== (countryKey as string)
    ? translatedCountry
    : fallback || isoCountryCode
}
